export default __webpack_public_path__ + "static/media/mi8.65400039.jpg";